import { GroupReservTable } from "./GroupReservTable";
import React from "react";
import { useIntl } from "react-intl";

export const GroupReserv = () => {
  const { messages } = useIntl();

  return (
    <div className="container-fluid">
      <div className="head_box">
        <h2 className="heading_dash mb-1">{messages["group_reservations"]}</h2>
        <p className="heading_dis">
          {messages["you_can_view_all_your_group_bookings_here"]}
        </p>
      </div>
      <GroupReservTable />
    </div>
  );
};
